export const isBasicLimitUser = (user) => (
  user?.orgRoleName === "Super Admin" ||
  user?.orgRoleName === "Admin" ||
  (
    user?.orgRoleName === "Viewer" &&
    user?.siteAccesses?.some((access) => access.siteRoleName === "Admin")
  )
);

export const shouldBlockBasicLimitUpdate = ({
  selectedRowData,
  originalRowData,
  combinedUserData,
  unityProSiteIds,
  unityProSiteCount,
  basicPrivilegedUserLimit,
}) => {
  if (
    !isBasicLimitUser(selectedRowData) ||
    isBasicLimitUser(originalRowData)
  ) {
    return false;
  }

  const hasUnlicensedSiteAdminAccess = selectedRowData.siteAccesses?.some(
    (access) => (
      access.siteRoleName === "Admin" &&
      !unityProSiteIds.includes(access.siteId)
    ),
  );
  const isOrgAdminWithoutPro = (
    unityProSiteCount === 0 &&
    ["Super Admin", "Admin"].includes(selectedRowData.orgRoleName)
  );

  if (!hasUnlicensedSiteAdminAccess && !isOrgAdminWithoutPro) {
    return false;
  }

  const otherCountedUsers = combinedUserData.filter((user) => {
    const isCurrentRow = selectedRowData.invitationId
      ? user.invitationId === selectedRowData.invitationId
      : user.id === selectedRowData.id;

    return !isCurrentRow && isBasicLimitUser(user);
  }).length;

  return otherCountedUsers >= basicPrivilegedUserLimit;
};
